import React, { PureComponent } from 'react'
import { bool, func, string } from 'prop-types'
import Responsive from '@active/react-utils/components/Responsive'
import Button from '@active/react-ui/Button'
import './AppleButton.scss'
import I18nMessage from '../I18nMessage'

class AppleButton extends PureComponent {
  static propTypes = {
    onIdpSignin: func.isRequired,
    name: string.isRequired,
    loginUrl: string,
    keycloakAPIServerHost: string,
    isPageModel: bool,
  }

  static defaultProps = {
    loginUrl: '',
    keycloakAPIServerHost: '',
    isPageModel: false,
  }

  handleClick = clickEvent => {
    const {
      loginUrl, keycloakAPIServerHost, onIdpSignin, name, isPageModel,
    } = this.props
    if (isPageModel) {
      const keycloakOrigin = new URL(keycloakAPIServerHost).origin
      window.location.href = `${keycloakOrigin}${loginUrl}`
      return false
    }

    return onIdpSignin({ clickEvent, name })
  }

  render() {
    return (
      <Responsive eqAbove="md" not>
        <Button type="secondary" className="passport__apple-btn" onClick={this.handleClick}>
          <i className="apple-btn-icon apple-img-r ic-apple" />
          <span className="apple-btn-text">
            <I18nMessage id="passport.common.text.signWithApple" />
          </span>
        </Button>
      </Responsive>
    )
  }
}

export default AppleButton
